<template>
    <div class="m-b-15 vld-parent">
        <loading :active="loading" :can-cancel="false" :is-full-page="false" />
        <div class="clearfix">
            <button type="button" class="btn btn-info btn-xs btn-outline pull-right" :disabled="loading" @click="generate">
                {{ $t("amas:analysis:pra:generate_description") }}
            </button>
            <h4 class="m-t-0 m-b-0">{{ $t("amas:analysis:pra:report_note") }}</h4>
        </div>
        <textarea class="form-control m-t-5" rows="5" style="resize: vertical;"
            :value="value"
            :placeholder="$t('amas:analysis:pra:report_note_placeholder')"
            @input="$emit('input', $event.target.value)"
        ></textarea>
    </div>
</template>

<script>
import { Swal } from "@/components/utils/swal.alerts.js";

export default {
    props: {
        value: { type: String, default: "" },
        generated: { type: String, default: "" },
        loading: { type: Boolean, default: false },
    },
    methods: {
        generate() {
            if (!this.value || this.value === this.generated) {
                this.$emit("generate");
                return;
            }
            Swal({
                title: this.$t("general:are_you_sure"),
                text: this.$t("amas:analysis:pra:generate_description_overwrite:alert"),
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: this.$t("general:yes"),
                cancelButtonText: this.$t("general:no_cancel"),
            }).then(val => { if (val.isConfirmed) { this.$emit("generate"); } });
        },
    },
}
</script>
